import type { CostFilters, CostLayer } from "../lib/types";
import type { DateRange } from "../lib/dateRange";

interface Props {
  range: DateRange;
  onRangeChange: (next: DateRange) => void;
  filters: CostFilters;
  onFiltersChange: (next: CostFilters) => void;
  showLayerFilter?: boolean;
  includeTodayLive?: boolean;
  onIncludeTodayLiveChange?: (next: boolean) => void;
}

const LAYERS: { value: CostLayer; label: string }[] = [
  { value: "L1", label: "L1 Embedding" },
  { value: "L2", label: "L2 Extraction" },
  { value: "L3", label: "L3 Surfaces" },
  { value: "L4", label: "L4 Agents" },
];

export default function FilterBar({
  range,
  onRangeChange,
  filters,
  onFiltersChange,
  showLayerFilter = false,
  includeTodayLive,
  onIncludeTodayLiveChange,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-4 bg-kw-bg-elevated border border-kw-border-subtle rounded p-3 text-sm">
      <label className="flex items-center gap-2">
        <span className="text-kw-text-muted">Von</span>
        <input
          type="date"
          value={range.from}
          onChange={(e) => onRangeChange({ ...range, from: e.target.value })}
          className="bg-kw-bg-deep border border-kw-border-subtle rounded px-2 py-1"
        />
      </label>
      <label className="flex items-center gap-2">
        <span className="text-kw-text-muted">Bis</span>
        <input
          type="date"
          value={range.to}
          onChange={(e) => onRangeChange({ ...range, to: e.target.value })}
          className="bg-kw-bg-deep border border-kw-border-subtle rounded px-2 py-1"
        />
      </label>
      <label className="flex items-center gap-2">
        <span className="text-kw-text-muted">Pack</span>
        <input
          type="text"
          placeholder="kw:personal"
          value={filters.pack_id ?? ""}
          onChange={(e) =>
            onFiltersChange({ ...filters, pack_id: e.target.value || undefined })
          }
          className="bg-kw-bg-deep border border-kw-border-subtle rounded px-2 py-1 w-32"
        />
      </label>
      <label className="flex items-center gap-2">
        <span className="text-kw-text-muted">op_class</span>
        <input
          type="text"
          placeholder="extraction"
          value={filters.op_class ?? ""}
          onChange={(e) =>
            onFiltersChange({ ...filters, op_class: e.target.value || undefined })
          }
          className="bg-kw-bg-deep border border-kw-border-subtle rounded px-2 py-1 w-32"
        />
      </label>
      {showLayerFilter ? (
        <label className="flex items-center gap-2">
          <span className="text-kw-text-muted">Layer</span>
          <select
            value={filters.cost_layer ?? ""}
            onChange={(e) =>
              onFiltersChange({
                ...filters,
                cost_layer: (e.target.value || undefined) as CostLayer | undefined,
              })
            }
            className="bg-kw-bg-deep border border-kw-border-subtle rounded px-2 py-1"
          >
            <option value="">alle</option>
            {LAYERS.map((l) => (
              <option key={l.value} value={l.value}>
                {l.label}
              </option>
            ))}
          </select>
        </label>
      ) : null}
      {onIncludeTodayLiveChange ? (
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={includeTodayLive ?? true}
            onChange={(e) => onIncludeTodayLiveChange(e.target.checked)}
            className="accent-kw-l3"
          />
          <span className="text-kw-text-muted">Live (heute einbeziehen)</span>
        </label>
      ) : null}
    </div>
  );
}
